document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll('.meganav-slick-slider-raj');

  sliders.forEach((slider) => {
    $(slider).owlCarousel({
    //   loop: true,
      loop: false,
      margin: 16,
      nav: true,
      dots: true,
      smartSpeed: 500,
      responsive: {
        0: { items: 2 },
        640: { items: 2 },
        768: { items: 4 },
        1024: { items: 7 }
      }
    });
  });
});




document.addEventListener("DOMContentLoaded", function () {
if(document.body.classList.contains('template-collection')){

var col_filter = document.querySelector('.productgrid--sidebar h2.productgrid--sidebar-title');

col_filter.addEventListener('click',function(){

    this.parentNode.classList.toggle('filter_active')
    
})

}

});




document.addEventListener("DOMContentLoaded", function () {
  if(document.body.classList.contains('template-collection')){
  const currentUrl = window.location.href.split('#')[0].split('?')[0]; // clean URL
  const nav = document.querySelector(".nav.header-nav.new-rajnavmenu");
  const sidebar = document.querySelector(".sidebar_categoryurlsec");



  // Find all anchor tags inside nav
  const links = document.querySelectorAll(".new-rajnavmenu .mega-column a");

  links.forEach(link => {
    let linkUrl = link.href.split('#')[0].split('?')[0]; // clean comparison

    if (linkUrl === currentUrl) {
      // Found the current URL link
      const megaColumn = link.closest(".mega-column");
      if (megaColumn) {
        // Get all anchor tags inside mega-column, excluding the current one
        const otherLinks = megaColumn.querySelectorAll("a[href]");
        sidebar.innerHTML = ""; // clear first

        otherLinks.forEach(other => {
          if (other !== link) {
            // clone to preserve text + attributes
            sidebar.appendChild(other.cloneNode(true));
          }
        });
      }
    }
  });
  }
});




document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains('template-collection')) {
    const currentUrl = window.location.href.split('#')[0].split('?')[0]; // clean URL
    const nav = document.querySelector(".nav.header-nav.new-rajnavmenu");

    // ✅ Desktop sidebar container
    const sidebarDesktop = document.querySelector(".sidebar_categoryurlsec");
    // ✅ Mobile sidebar container
    const sidebarMobile = document.querySelector(".sidebar_categoryurlsec-mob");

    // Find all anchor tags inside nav
    const links = document.querySelectorAll(".new-rajnavmenu .mega-column a");

    links.forEach(link => {
      let linkUrl = link.href.split('#')[0].split('?')[0]; // clean comparison

      if (linkUrl === currentUrl) {
        // Found the current URL link
        const megaColumn = link.closest(".mega-column");
        if (megaColumn) {
          // Get all anchor tags inside mega-column, excluding the current one
          const otherLinks = megaColumn.querySelectorAll("a[href]");

          // ✅ Clear both desktop & mobile containers
          if (sidebarDesktop) sidebarDesktop.innerHTML = "";
          if (sidebarMobile) sidebarMobile.innerHTML = "";

          otherLinks.forEach(other => {
            if (other !== link) {
              // clone to preserve text + attributes
              const cloned = other.cloneNode(true);

              // ✅ Append to desktop sidebar
              if (sidebarDesktop) sidebarDesktop.appendChild(cloned.cloneNode(true));
              // ✅ Append to mobile sidebar
              if (sidebarMobile) sidebarMobile.appendChild(cloned.cloneNode(true));
            }
          });
        }
      }
    });
  }
});





 $('.product-gallery--viewer').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  arrows: true, // Ensure arrows are enabled
      prevArrow: '<button class="carousel-btn prev" data-target="tab-{{ block.id }}">&#10094;</button>',
      nextArrow: '<button class="carousel-btn next" data-target="tab-{{ block.id }}">&#10095;</button>',
  asNavFor: '.gallery-navigation--scroller',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          arrows: true,
        
      }
    }
  ]
});
$('.gallery-navigation--scroller').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  asNavFor: '.product-gallery--viewer',
  dots: false,
  centerMode: true,
  arrows:false,
  focusOnSelect: true,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,

        
      }
    }
  ]
});